import { motion } from "framer-motion";
import { Beer, UtensilsCrossed, CalendarDays, Clock } from "lucide-react";
import { DemoBar } from "@/components/DemoBar";
import { CASES } from "@/data/cases";

const img = CASES.find((c) => c.slug === "hygge-tavern").image;

const MENU = [
  { name: "Stegt flæsk m. persillesovs", price: "145 kr" },
  { name: "Frikadeller m. kartoffelsalat", price: "125 kr" },
  { name: "Smørrebrød — 3 stk.", price: "98 kr" },
  { name: "Husets fadøl — 50 cl", price: "55 kr" },
];

export default function HyggeTavernDemo() {
  return (
    <div data-testid="demo-hygge-tavern" className="min-h-screen bg-[#171009] text-[#F0E6D8]">
      <DemoBar name="Den Hyggelige Taverna" />

      <header className="flex items-center justify-between px-6 py-6 md:px-12">
        <p className="font-syne text-xl font-extrabold tracking-tight">
          Den Hyggelige <span className="text-[#E0A458]">Taverna</span>
        </p>
        <button data-testid="tavern-book-button" className="rounded-full bg-[#E0A458] px-6 py-2.5 text-sm font-bold text-[#171009] transition-transform duration-300 hover:scale-105">
          Book bord
        </button>
      </header>

      <section className="relative flex min-h-[80vh] items-center overflow-hidden">
        <img src={img} alt="Stemning på Den Hyggelige Taverna" data-testid="tavern-hero-image" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#171009] via-[#171009]/70 to-transparent" />
        <motion.div initial={{ opacity: 0, y: 40 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9 }} className="relative px-6 py-24 md:px-12">
          <p className="flex items-center gap-2 text-sm uppercase tracking-[0.3em] text-[#E0A458]">
            <Beer className="h-4 w-4" /> Siden 1987
          </p>
          <h1 className="mt-4 max-w-2xl font-syne text-5xl font-extrabold uppercase leading-[0.92] tracking-tighter md:text-7xl">
            Levende lys &amp; gode historier
          </h1>
          <p className="mt-6 max-w-md text-[#CBB896]">
            En vaskeægte kro midt i byen. Kom som du er — gå som en ven. Dansk mad, kolde fadøl og varme stole.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <button data-testid="tavern-hero-book-cta" className="group flex items-center gap-2 rounded-full bg-[#E0A458] px-8 py-4 text-sm font-bold text-[#171009] transition-transform duration-300 hover:scale-105">
              <CalendarDays className="h-4 w-4" /> Book et bord
            </button>
            <span className="flex items-center gap-2 rounded-full border border-white/20 px-6 py-4 text-sm text-[#CBB896]">
              <Clock className="h-4 w-4 text-[#E0A458]" /> Man–Søn 16–24
            </span>
          </div>
        </motion.div>
      </section>

      <section className="border-t border-white/10 px-6 py-20 md:px-12">
        <div className="flex items-center gap-3">
          <UtensilsCrossed className="h-6 w-6 text-[#E0A458]" />
          <h2 className="font-syne text-3xl font-extrabold uppercase tracking-tighter md:text-5xl">Kroens favoritter</h2>
        </div>
        <div data-testid="tavern-menu" className="mt-10 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2">
          {MENU.map((m, i) => (
            <motion.div
              key={m.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="flex items-center justify-between bg-[#171009] p-8 transition-colors duration-300 hover:bg-[#1F1509]"
            >
              <p className="font-syne text-lg font-bold">{m.name}</p>
              <p className="font-syne text-lg font-bold text-[#E0A458]">{m.price}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <footer className="border-t border-white/10 px-6 py-10 text-center text-sm text-[#CBB896] md:px-12">
        Den Hyggelige Taverna · Krogade 7 · 5000 Odense C · Tlf. 65 43 21 09
      </footer>
    </div>
  );
}
